import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { AuthService } from '../../../modules/cloud';
import { AppContainer } from '../../components/app-container';

const PUBLIC_PATH_PREFIXES = [
  '/sign-in',
  '/signin',
  '/magic-link',
  '/oauth',
  '/auth',
  '/share',
  '/invite',
  '/open-app',
  '/desktop-signin',
  '/redirect-proxy',
  '/expired',
  '/404',
];

const isPublicPath = (pathname: string) => {
  const lower = pathname.toLowerCase();
  return PUBLIC_PATH_PREFIXES.some(
    prefix => lower === prefix || lower.startsWith(prefix + '/')
  );
};

export const AuthGuard = () => {
  const authService = useService(AuthService);
  const status = useLiveData(authService.session.status$);
  const isRevalidating = useLiveData(authService.session.isRevalidating$);
  const location = useLocation();
  const navigate = useNavigate();

  const onPublicPath = isPublicPath(location.pathname);

  useEffect(() => {
    if (isRevalidating) return;
    if (status === 'unauthenticated' && !onPublicPath) {
      navigate('/sign-in', { replace: true });
    }
  }, [isRevalidating, status, onPublicPath, navigate]);

  if (status === 'unauthenticated' && !onPublicPath) {
    return <AppContainer fallback />;
  }

  return <Outlet />;
};
